import { useState, useEffect } from 'react';

// Hook that loads a script up and lets the parent know when it's
const useDynamicScript = url => {
	const [ready, setReady] = useState(false);
	const [failed, setFailed] = useState(false);

	useEffect(() => {
		if (!url) {
			return () => {};
		}

		const element = document.createElement('script');

		element.src = url;
		element.type = 'text/javascript';
		element.async = true;

		setReady(false);
		setFailed(false);

		element.onload = () => {
			setReady(true);
		};

		element.onerror = () => {
			setReady(false);
			setFailed(true);
		};

		document.head.appendChild(element);

		return () => {
			document.head.removeChild(element);
		};
	}, [url]);

	return {
		ready,
		failed
	};
};

export default useDynamicScript;
